import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [sessionId, setSessionId] = useState('');

  const updateUserInfo = (info) => {
    setUserInfo(info);
  };

  const updateSessionId = (id) => {
    setSessionId(id);
  };

  const clearUserInfo = () => {
    setUserInfo(null);
    setSessionId('');
  };

  return (
    <UserContext.Provider
      value={{
        userInfo,
        sessionId,
        updateUserInfo,
        updateSessionId,
        clearUserInfo
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

